// extracted by mini-css-extract-plugin
module.exports = {"loading":"spinner_loading__30Mxw","bubble":"spinner_bubble__3-IPB","fade":"spinner_fade__2HO4_"};